import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import qs from 'qs';

import { useToaster } from '@components/toaster';

import { Loading } from 'components/Loading';
import { useStore } from 'models/Provider';

function SlackAuth() {
  const { t, api } = useStore();
  const { showSuccess, showError } = useToaster();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const parsed = qs.parse(location.search, { ignoreQueryPrefix: true });
    const code = parsed.code;
    api.users.authenticateSlack(code).then((res) => {
      if (res && res.status === 200) {
        if (res.data && res.data.bot) {
          showSuccess(t('slack.success.bot'));
        } else {
          showSuccess(t('slack.success.user'));
        }
        navigate('/');
      }
    });
  }, [showSuccess, showError, t, api.users, location.search, navigate]);

  return <Loading />;
}

export default observer(SlackAuth);
